import { Flex } from '@chakra-ui/react';
import React from 'react';

import CustomButton from '@/common/CustomButton/CustomButton';
import './ShowMore.scss';

interface ShowMoreProps {
  showMore: {
    current: number;
    total: number;
    showMoreResources: () => void;
  };
}

const ShowMore = ({ showMore }: ShowMoreProps) => (
  <Flex className={'show-more-container'}>
    <Flex className={'show-more-showing-text'}>
      Showing {showMore.current} of {showMore.total} results
    </Flex>

    <CustomButton onClick={showMore.showMoreResources} variant={'ghost'}>
      Show More
    </CustomButton>
  </Flex>
);
export default ShowMore;
